import axios, { AxiosResponse } from "axios";
import { atom, useRecoilState } from "recoil";
import { RECOIL_KEY } from "globalState/key";
import { Photo, PhotoWithIndex } from "type";
import { API_BASE_URL } from "config";

const photoBlobsAtom = atom<PhotoWithIndex[]>({
  key: RECOIL_KEY.PHOTO_BLOBS,
  default: []
})

const oldestTimeAtom = atom<number>({
  key: RECOIL_KEY.OLDEST_TIME,
  default: new Date().getTime()
})

const retrieveNumber = 30

const fetchPhoto = async (to: number, fetchNumber: number): Promise<AxiosResponse<Photo[]>>=> {
  return  axios.get(API_BASE_URL + '/image',{
    params:{
      to: to,
      number: fetchNumber 
    }
  })
}

const addIndexToPhoto = (photos : Photo[], indexOffset: number): PhotoWithIndex[]=>{
  const photoBlobs  = photos.map((v, idx):PhotoWithIndex=>{
      return {takenYear: v.takenYear, timestamp: v.timestamp, filename: v.filename,  index: indexOffset + idx, type: v.type}
    })
  return photoBlobs
}

export const usePhotoBlobs = (): [PhotoWithIndex[], (olderThan :number)=>Promise<void>, ()=>Promise<void>]=>{
  const [blob, setBlob] = useRecoilState(photoBlobsAtom)
  const [oldestTime, setOldestTime] = useRecoilState(oldestTimeAtom)

  const setPhotoBlob = async (olderThan : number) =>{
    const res = await fetchPhoto(olderThan, retrieveNumber)
    const photoBlob = await addIndexToPhoto(res.data, 0)
    setBlob(photoBlob)
    setOldestTime(photoBlob.reduce((p,c)=>{
      return p.timestamp < c.timestamp? p: c
    }).timestamp)
  }
  
  const addPhotoBlob = async ()=>{
    const res = await fetchPhoto(oldestTime, retrieveNumber)
    const photoBlob = addIndexToPhoto(res.data, blob.length)
    setBlob(blob.concat(photoBlob))
    setOldestTime(photoBlob.reduce((p,c)=>{
      return p.timestamp < c.timestamp? p: c
    }).timestamp)
  }
  return [blob, setPhotoBlob, addPhotoBlob]
}